import React from 'react';
import AuthLayout from '../components/AuthLayout';

/*
 * Checking the stored token and exchanging the Cognito code both happen before
 * anything renders, which showed as a blank white page — indistinguishable from
 * a failed load on a slow connection.
 */
function AuthLoading({ message = 'Signing you in…' }) {
  return (
    <AuthLayout glow={false}>
      <div className="flex items-center gap-3">
        <span
          className="h-5 w-5 flex-shrink-0 animate-spin rounded-full border-2 border-gray-200 border-t-rewardsco-600"
          aria-hidden="true"
        />
        <p className="text-sm font-medium text-gray-700">{message}</p>
      </div>

      {/* Skeleton of the shell being prepared, matching the app's loading
          language rather than introducing a second one. */}
      <div className="mt-8 space-y-3" aria-hidden="true">
        <div className="skeleton-bar h-10 w-full rounded-lg" />
        <div className="skeleton-bar h-10 w-4/5 rounded-lg" />
        <div className="skeleton-bar h-10 w-3/5 rounded-lg" />
      </div>
    </AuthLayout>
  );
}

export default AuthLoading;
